import { Navigate, useLocation } from "src/router";
import { useLifecycleStudioEnabled } from "src/hooks/use-lifecycle-studio-enabled";
import { useIsAdStudioEnabled } from "src/pages/agents/hooks/use-is-ad-studio-enabled";

export const GuardrailsIndexRedirect = ({
  legacy = false,
}: {
  legacy?: boolean;
}) => {
  const adsEnabled = useIsAdStudioEnabled();
  const emailsEnabled = useLifecycleStudioEnabled();
  const location = useLocation();
  const tab =
    legacy && emailsEnabled
      ? "emails"
      : adsEnabled
        ? "ads"
        : emailsEnabled
          ? "emails"
          : null;

  return (
    <Navigate
      to={{
        pathname: tab
          ? `/context-hub/guardrails/${tab}`
          : "/context-hub/knowledge/files",
        search: location.search,
      }}
      state={location.state}
      replace
    />
  );
};
